import { MutationType } from '@tencent/slide-sdk-pb-model';
import { BaseMutation } from '../base/base-mutation';
import { Rule } from '../base/mutation-rules';
import type { MaybeError } from '../base/base-mutation';
import type { IValidAddThemeMutationData, IValidRemoveThemeMutationData } from '../base/valid-mutation-data';
import type { PresentationDataModel } from '../../model/presentation-data-model';

export class RemoveThemeMutation extends BaseMutation<PresentationDataModel, IValidRemoveThemeMutationData> {
    public readonly type: MutationType = MutationType.RemoveTheme;

    public apply(presentation: PresentationDataModel) {
        const { themeId } = this.data;
        presentation.store.removeTheme(themeId);
    }

    public invert(presentation: PresentationDataModel): [IValidAddThemeMutationData] {
        const { themeId } = this.data;
        const theme = presentation.store.getThemeById(themeId);
        const mutData: IValidAddThemeMutationData = {
            type: MutationType.AddTheme,
            themeId,
            themeName: theme?.store.data.name || '',
            themeElements: theme?.store.data.themeElements || {},
        };
        return [mutData];
    }

    public check(presentation: PresentationDataModel): MaybeError {
        const { themeId } = this.data;
        return Rule.every(
            Rule.theme.should.existInPresentation(presentation, themeId),
            Rule.theme.should.notUsedInMaster(presentation, themeId),
        );
    }
}
